import { PatientCard } from './PatientCard';
import { ConsultationCard } from './ConsultationCard';
import { FileViewer } from './FileViewer';
import { MeasuresTable } from './MeasuresTable';
// Assuming WaitingRoomCard and FormResults exist and are structured similarly
// import { WaitingRoomCard } from './WaitingRoomCard';
// import { FormResults } from './FormResults';
import { ToolCallDisplay } from './ToolCallDisplay';
import { ToolCallGroup } from './ToolCallGroup';
import { type ComponentType } from 'react';

// Define a type for the registry to ensure consistency
export type ComponentRegistryType = {
    [key: string]: ComponentType<any>;
};

const ComponentRegistry: ComponentRegistryType = {
    'patient_card': PatientCard,
    'consultation_card': ConsultationCard,
    'file_viewer': FileViewer,
    'measures_table': MeasuresTable,
    // 'waiting_room_card': WaitingRoomCard,
    // 'form_results': FormResults,
    'tool_interaction': ToolCallDisplay,
    'tool_call_group': ToolCallGroup,
};

export const getComponent = (name: string): ComponentType<any> | undefined => {
    return ComponentRegistry[name];
};

export default ComponentRegistry; 